// Landing QLK Fest 2026 · 2da edición (diseño "LANDING QLKFest 2026 v2.pdf")
import React, { useEffect, useRef, useState } from "react";
import "./Landing26.css";
import Header26, { Footer26 } from "./Chrome26";
import MusicPlayer26 from "./MusicPlayer26";
import { SHOW_SECTORES, SHOW_PERMISO, SHOW_LINEUP_PAGE, SHOW_PUNTOS } from "./config";
import {
  Hero,
  ElFesti,
  Entradas,
  EntradaGeneral,
  EntradaVip,
  EntradaUltra,
  EntradaParking,
  Abonos,
  LineUp,
  Sectores,
  PuntosVenta,
  Permiso,
  Contacto,
} from "./Sections26";

// Qué botón del menú queda activo según la sección visible
const MENU_OF = {
  festi: "festi",
  lineup: "lineup",
  entradas: "entradas",
  "entrada-general": "entradas",
  "entrada-vip": "entradas",
  "entrada-ultra": "entradas",
  "entrada-parking": "entradas",
  abonos: "entradas",
  sectores: "sectores",
  puntos: "puntos",
  permiso: "permiso",
  contacto: "contacto",
};

export default function Landing26() {
  const refs = useRef({});
  const [visible, setVisible] = useState("home");
  const reg = (id) => (el) => {
    refs.current[id] = el;
  };

  useEffect(() => {
    const els = Object.values(refs.current).filter(Boolean);
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) setVisible(e.target.id);
        });
      },
      { rootMargin: "-45% 0px -45% 0px" }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  // Link compartido (…/#entrada-vip): ir a esa sección al abrir la página
  useEffect(() => {
    const id = decodeURIComponent(window.location.hash.slice(1));
    if (!id) return;
    const t = setTimeout(() => {
      const el = refs.current[id];
      if (!el) return;
      setFocus(id);
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY });
    }, 400);
    return () => clearTimeout(t);
  }, []);

  // Cada sección ya deja lugar arriba para el header fijo (en compu y en celular),
  // así que se lleva al borde superior: se ve entera y sin la siguiente asomando.
  const headerOffset = () => 0;
  const targetTop = (el) => el.getBoundingClientRect().top + window.scrollY - headerOffset();
  const settleRef = useRef(null);

  // En celular, al scrollear las secciones son compactas (poco espacio entre una y otra).
  // La sección a la que se va por el menú queda "enfocada": ocupa una pantalla
  // completa, así se ve sola, sin asomar la de arriba ni la de abajo (ver CSS .is-focus).
  const focusRef = useRef(null);
  const setFocus = (id) => {
    const prev = focusRef.current && refs.current[focusRef.current];
    if (prev) prev.classList.remove("is-focus");
    const el = refs.current[id];
    if (el) el.classList.add("is-focus");
    focusRef.current = id;
  };

  const navigate = (id) => {
    const el = refs.current[id];
    if (!el) return;
    setFocus(id); // cambia el alto antes de calcular a dónde ir
    window.scrollTo({ top: targetTop(el), behavior: "smooth" });

    // Cuando el scroll termina, verificar que quedó en la sección pedida
    // (si una imagen terminó de cargar en el medio, el destino se corre) y corregir.
    cancelAnimationFrame(settleRef.current);
    let lastY = -1;
    let still = 0;
    const started = Date.now();
    const check = () => {
      const y = window.scrollY;
      still = Math.abs(y - lastY) < 1 ? still + 1 : 0;
      lastY = y;
      if (still >= 8 || Date.now() - started > 3000) {
        if (Math.abs(el.getBoundingClientRect().top - headerOffset()) > 2) {
          window.scrollTo({ top: targetTop(el) });
        }
        return;
      }
      settleRef.current = requestAnimationFrame(check);
    };
    settleRef.current = requestAnimationFrame(check);
  };

  return (
    <div className="q26">
      <Header26 active={MENU_OF[visible]} onNavigate={navigate} />
      <main>
        <Hero ref={reg("home")} />
        <ElFesti ref={reg("festi")} onNavigate={navigate} />
        {SHOW_LINEUP_PAGE && <LineUp ref={reg("lineup")} />}
        <Entradas ref={reg("entradas")} onNavigate={navigate} />
        <EntradaGeneral ref={reg("entrada-general")} />
        <EntradaVip ref={reg("entrada-vip")} />
        <EntradaUltra ref={reg("entrada-ultra")} />
        <EntradaParking ref={reg("entrada-parking")} />
        <Abonos ref={reg("abonos")} />
        {SHOW_SECTORES && <Sectores ref={reg("sectores")} />}
        {SHOW_PUNTOS && <PuntosVenta ref={reg("puntos")} />}
        {SHOW_PERMISO && <Permiso ref={reg("permiso")} />}
        <Contacto ref={reg("contacto")} />
      </main>
      <Footer26 showCountdown={visible === "home"} />
      <MusicPlayer26 />
    </div>
  );
}
